import * as React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../helpers/axios';
import { formatDate } from '../helpers/custom';
import { Card, CardContent, CardActions, Grid, Typography, Button, Backdrop, CircularProgress, CardHeader, ButtonGroup, Modal, Box, IconButton, Divider, FormControl, TextField } from '@mui/material';
// import 'react-toastify/dist/ReactToastify.css';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from "react-chartjs-2";
import { withTranslation, WithTranslation } from 'react-i18next';
import { CloseOutlined, Air, Forest, EditOutlined } from '@mui/icons-material';
import { LocalShippingOutlined, PeopleOutlined, PaymentsOutlined, DeleteSweepOutlined, LocalGasStationOutlined } from '@mui/icons-material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DataGrid, GridCellParams, GridRowParams } from '@mui/x-data-grid';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    showLoader: boolean;
    totalPickups: string;
    totalKgs: string;
    completedPickups: string;
    totalRegisteredUsers: string;
    co2Averted: string;
    treesSaved: string;
    fuelSaved: string;
    weightReportDataBar: any;
    weightReportBarChartOptions: any;
    duration: any;
    showCustomDateFilter: boolean;
    customFromDate?: string | null;
    customToDate?: string | null;
    payment_pending_pickups: any;
    requestLoading: any;
    totalCustomer: any;
}

class Home extends React.Component<RouteComponentProps & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            showLoader: false,
            totalPickups: '0',
            totalKgs: '0', //Round of the value to 1 decimal point
            completedPickups: '0',
            totalRegisteredUsers: '0',
            co2Averted: '0', //Round of the value to 1 decimal point
            treesSaved: '0', //Round of the value to 1 decimal point
            fuelSaved: '0', //Round of the value to 1 decimal point
            weightReportDataBar: {
                labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                datasets: [
                    {
                        label: 'kg',
                        data: [],
                        backgroundColor: 'rgba(32, 77, 54, 0.5)',
                        borderWidth: 2,
                        borderColor: 'rgba(32, 77, 54, 1)'
                    }
                ]
            },
            weightReportBarChartOptions: {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'bottom' as const,
                    },
                    title: {
                        display: false,
                        // text: 'Waste Collected',
                    },
                    datalabels: { display: false }, 
                },
                scales: {
                    x: {
                        grid: {
                            display: true,
                            color: '#F8F8F8'
                        }
                    },
                    y: {
                        grid: {
                            display: true,
                            color: '#F8F8F8'
                        }
                    }
                }
            },
            duration: 'current_month',
            showCustomDateFilter: false,
            customFromDate: null,
            customToDate: null,
            payment_pending_pickups: [],
            requestLoading: false,
            totalCustomer: '0',
        }
    }
    public componentDidMount(): void {
        // axios.get(`curation-stats`).then(response => {
        //     this.setState({ curation_stats: response.data.data })
        // });
        /*this.setState({ showLoader: true });
        let date = new Date();
        let data = {
            'start_date': new Date(date.setDate(date.getDate() - 90)).toLocaleDateString().split('/').reverse().join('-'),
            'end_date': new Date().toLocaleDateString().split('/').reverse().join('-'),
            'hierarchies': [1]
        };
        axios.post(`dashboardAnalytics`, data).then((response: any) => {
            let data: any = response.data.data;
            this.setState({
                showLoader: false,
                totalPickups: data.total_pickups,
                totalKgs: data.new_customer,
                completedPickups: data.payment_pending,
                co2Averted: data.sorted_waste,
                treesSaved: data.payment_collected,
                fuelSaved: data.payment_pending
            });
        }).catch((error) => {
            console.log(error);
        });*/

        if(localStorage.getItem('homePageTimePeriod')){
            this.setState({ duration: localStorage.getItem('homePageTimePeriod') }, () => this.fetchDashboardAnalytics());
            if(localStorage.getItem('homePageTimePeriod') == "custom"){
                if(localStorage.getItem('homePageTimePeriodCustomFromDate') && localStorage.getItem('homePageTimePeriodCustomToDate')){
                    this.setState({ 
                        customFromDate: localStorage.getItem('homePageTimePeriodCustomFromDate'),
                        customToDate: localStorage.getItem('homePageTimePeriodCustomToDate')
                    }, () => this.fetchDashboardAnalytics());
                }
            }
        }else{
            this.fetchDashboardAnalytics();
        }
        
        this.fetchPendingPayments();
        this.fetchCustomerStats();
    }

    public fetchDashboardAnalytics = (filter: string = this.state.duration) => {
        if (this.props.user.selectedHierarchyIds.length) {
            this.setState({ showLoader: true });
            let date = new Date();
            let data: any = {
                // 'start_date': formatDate(date.setDate(date.getDate() - 30), 'Y-m-d'),
                // 'end_date': formatDate(new Date(), 'Y-m-d'),
                'hierarchies': this.props.user.selectedHierarchyIds
            };
            if (filter == "custom") {
                data.start_date = (this.state.customFromDate) ? formatDate(this.state.customFromDate, 'Y-m-d') : "";
                data.end_date = (this.state.customToDate) ? formatDate(this.state.customToDate, 'Y-m-d') : "";
            } else if(filter == 'month') {
                // console.log('filter', filter)
                // data.start_date = formatDate(date.setDate(date.getDate() - 30), 'Y-m-d');
                // data.end_date = formatDate(new Date(), 'Y-m-d');
                data.start_date = formatDate(new Date(date.getFullYear(), date.getMonth() - 1, 1), 'Y-m-d');
                data.end_date = formatDate(new Date(date.getFullYear(), date.getMonth(), 0), 'Y-m-d');
                // data.filter = filter;
            } else if(filter == 'week') {
                // console.log('filter', filter)
                data.start_date = formatDate(new Date().setDate(date.getDate() - 7), 'Y-m-d');
                data.end_date = formatDate(new Date().setDate(date.getDate() - 1), 'Y-m-d');
                // data.filter = filter;
            } else if(filter == 'today'){
                // console.log('filter', filter)
                data.start_date = formatDate(new Date(), 'Y-m-d');
                data.end_date = formatDate(new Date(), 'Y-m-d');
            } else if (filter == 'current_month') {
                // Set start date to the 1st day of the current month
                data.start_date = formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'Y-m-d');
                
                // Set end date to the last day of the current month
                data.end_date = formatDate(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'Y-m-d');
            }
            
            axios.post(`dashboardAnalytics`, data, {headers: {"Content-Type": "application/json"}}).then((response: any) => {
                if (response.data.success) {
                    let data: any = response.data.data;
                    let weightReportDataBar = this.state.weightReportDataBar;
                    weightReportDataBar.labels = Object.keys(data.chart);
                    weightReportDataBar.datasets[0].data = Object.values(data.chart);
                    // console.log("data", data);
                    console.log(response);
                    this.setState({
                        showLoader: false,
                        requestLoading:false,
                        totalKgs: (data.total_kg) ? parseFloat(data.total_kg.toString()).toLocaleString() : '0',
                        totalPickups: (data.total_pickups) ? parseFloat(data.total_pickups.toFixed(2).toString()).toLocaleString(): '0',
                        completedPickups: (data.pickups_complete) ? parseFloat(data.pickups_complete.toFixed(2).toString()).toLocaleString(): '0',
                        co2Averted: (data.info.co2) ? parseInt(data.info.co2.toFixed(2).toString()).toLocaleString() : '0',
                        treesSaved: (data.info.tree_saved) ? parseInt(data.info.tree_saved.toFixed(2).toString()).toLocaleString() : '0',
                        fuelSaved: (data.info.oil_saved) ? parseInt(data.info.oil_saved.toFixed(2).toString()).toLocaleString() : '0',
                        totalCustomer: (data.totalActiveCustomers) ? parseFloat(data.totalActiveCustomers.toFixed(2).toString()).toLocaleString() : '0',
                        showCustomDateFilter: false
                    });
                }else{
                    this.setState({ showLoader: false });
                }
            }).catch((error) => {
                console.log(error);
            });
        }
    }

    public fetchPendingPayments = () => {
        axios.get('pendingPayments').then((resp: any) => {
            if(resp.data.success){
                this.setState({payment_pending_pickups: resp.data.data?.map((el: any) => {
                    return{
                        "id": el.id,
                        "user_id": el.user_id,
                        "weight": el.complete_weight.total,
                        "pickup_date": el.pickup_date,
                        "pickup_total": el.pickup_total,
                    }
                })})
            } else {
                console.log("err",resp.data.msg);
            }
        }).catch((err) => console.log("err",err))
    }

    public fetchCustomerStats() {
        if (this.props.user.selectedHierarchyIds.length) {
            axios.get(`customerActiveStatus`, { params: { "hierarchies": this.props.user.selectedHierarchyIds } }).then(response => {
                let data: any = response.data.data;
                this.setState({
                    totalRegisteredUsers: parseInt((data.active + data.inactive).toString()).toLocaleString()
                });
            });
        }
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const columns = [
                {
                    headerName: "PickupID",
                    field: "id",
                    width: 100,
                  },
                  {
                    headerName: "UserID",
                    field: "user_id",
                    width: 150,
                  },
                  {
                    headerName: "Pickup Total",
                    field: "pickup_total",
                    width: 150,
                  },
                  {
                    headerName: "Weight",
                    field: "weight",
                    width: 150,
                  },
                  {
                    headerName: "Pickup Date",
                    field: "pickup_date",
                    width: 180,
                  },
                  {
                    headerName: "Actions",
                    field: "actions",
                    type: "actions",
                    width: 350,
                    renderCell: (params: GridCellParams) => (
                        <Grid container spacing={2}>
                            <Grid item md={6} xs={12}>
                                <Link to={`/neighbourhood/community-list/${params.id}/users`} style={{ textDecoration: 'none' }}>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        className="float-right"
                                        tabIndex={params.hasFocus ? 0 : -1}
                                        >
                                        Publish Payment
                                    </Button>
                                </Link>
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <Link to={`/neighbourhood/community-list/${params.id}/users`} style={{ textDecoration: 'none' }}>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        className="float-right"
                                        tabIndex={params.hasFocus ? 0 : -1}
                                        >
                                        Cancel Payment
                                    </Button>
                                </Link>
                            </Grid>
                        </Grid>
                        
                    )
                  }
                ]
        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme: any) => theme.zIndex.drawer + 1 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <Typography variant="h4" className='page-title'>
                    {t("Home")}
                    <ButtonGroup variant="contained" className="diversionButtonGroup float-right" aria-label="Material Flow of Diverted Waste button group">
                        <Button className={(this.state.duration == 'today') ? "active" : ""} onClick={() => { this.setState({ duration: 'today' }, () => localStorage.setItem('homePageTimePeriod', 'today')); this.fetchDashboardAnalytics('today')}}>{t("Today")}</Button>
                        <Button className={(this.state.duration == 'week') ? "active" : ""} onClick={() => { this.setState({ duration: 'week' }, () => localStorage.setItem('homePageTimePeriod', 'week')); this.fetchDashboardAnalytics('week')}}>{t("Week")}</Button>
                        <Button className={(this.state.duration == 'current_month') ? "active" : ""} onClick={() => { this.setState({ duration: 'current_month' }, () => localStorage.setItem('homePageTimePeriod', 'current_month')); this.fetchDashboardAnalytics('current_month')}}>{t("Current Month")}</Button>
                        <Button className={(this.state.duration == 'month') ? "active" : ""} onClick={() => { this.setState({ duration: 'month' }, () => localStorage.setItem('homePageTimePeriod', 'month')); this.fetchDashboardAnalytics('month')}}>{t("Last Month")}</Button>
                        <Button className={(this.state.duration == 'custom') ? "active" : ""} onClick={() => { this.setState({ duration: 'custom', showCustomDateFilter: true }); }}>{t("Custom")}</Button>
                    </ButtonGroup>
                </Typography>
                <Grid container spacing={2}>
                    <Grid item md={6} xs={12}>
                        <Card>
                            {/* <CardActions>
                                <Button size="small" variant='contained' className='link' component={Link} to={'/incoming-waste'}>View Incoming Waste</Button>
                                <Button size="small" variant='contained' className='link' component={Link} to={'/diverted-waste'}>View Diverted Waste</Button>
                                <Button size="small" variant='contained' className='link' component={Link} to={'/outgoing-waste'}>View Outgoing Waste</Button>
                            </CardActions> */}
                            <CardHeader title="Statistics" sx={{ textAlign: 'left' }} />
                            <CardContent sx={{ minHeight: '63vh' }}>
                                <Grid container spacing={2} className='mt-2 mb-4'>
                                    <Grid item md={4} xs={12} className="text-center">
                                        <Card sx={{ justifyContent: "center", display: "flex" }}>
                                            <CardContent>
                                                <LocalShippingOutlined sx={{ width: 56, height: 56, color: '#204d36' }} />
                                                <Typography variant="body1" component="div">
                                                    {this.state.totalPickups}
                                                </Typography>
                                                <Typography variant="body2" sx={{ fontSize: '12px', marginTop: '10px' }}>
                                                    {t("Total Pickups")}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item md={4} xs={12} className="text-center">
                                        <Card sx={{ justifyContent: "center", display: "flex" }}>
                                            <CardContent>
                                                <DeleteSweepOutlined sx={{ width: 56, height: 56, color: '#204d36' }} />
                                                <Typography variant="body1" component="div">
                                                    {this.state.totalKgs}
                                                </Typography>
                                                <Typography variant="body2" sx={{ fontSize: '12px', marginTop: '10px' }}>
                                                    {t("Total kg")}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    {/* <Grid item md={4} xs={12} className="text-center">
                                        <Card sx={{ justifyContent: "center", display: "flex" }}>
                                            <CardContent>
                                                <LocalShippingOutlined sx={{ width: 56, height: 56, color: '#204d36' }} />
                                                <Typography variant="body1" component="div">
                                                    {this.state.completedPickups}
                                                </Typography>
                                                <Typography variant="body2" sx={{ fontSize: '12px', marginTop: '10px' }}>
                                                    {t("Completed Pickups")}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid> */}
                                    <Grid item md={4} xs={12} className="text-center">
                                        <Card sx={{ justifyContent: "center", display: "flex" }}>
                                            <CardContent>
                                                <PeopleOutlined sx={{ width: 56, height: 56, color: '#204d36' }} />
                                                <Typography variant="body1" component="div">
                                                    {this.state.totalRegisteredUsers}
                                                </Typography>
                                                <Typography variant="body2" sx={{ fontSize: '12px', marginTop: '10px' }}>
                                                    {t("Registered Users")}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item md={4} xs={12} className="text-center">
                                        <Card sx={{ justifyContent: "center", display: "flex" }}>
                                            <CardContent>
                                                <Air sx={{ width: 56, height: 56, color: '#204d36' }} />
                                                <Typography variant="body1" component="div">
                                                    ~{this.state.co2Averted} kg
                                                </Typography>
                                                <Typography variant="body2" sx={{ fontSize: '12px', marginTop: '10px' }}>
                                                    CO<sub>2</sub> eq {t("Averted")}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item md={4} xs={12} className="text-center">
                                        <Card sx={{ justifyContent: "center", display: "flex" }}>
                                            <CardContent>
                                                <Forest sx={{ width: 56, height: 56, color: '#204d36' }} />
                                                <Typography variant="body1" component="div">
                                                    ~{this.state.treesSaved}
                                                </Typography>
                                                <Typography variant="body2" sx={{ fontSize: '12px', marginTop: '10px' }}>
                                                    {t("Trees Saved")}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item md={4} xs={12} className="text-center">
                                        <Card sx={{ justifyContent: "center", display: "flex" }}>
                                            <CardContent>
                                                <LocalGasStationOutlined sx={{ width: 56, height: 56, color: '#204d36' }} />
                                                <Typography variant="body1" component="div">
                                                    ~{this.state.fuelSaved} L
                                                </Typography>
                                                <Typography variant="body2" sx={{ fontSize: '12px', marginTop: '10px' }}>
                                                    {t("Fuel Saved")}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <Card>
                            <CardHeader title="Weight Report" sx={{ textAlign: 'left' }} />
                            <CardContent sx={{ minHeight: '63vh' }}>
                                <Grid container spacing={2} justifyContent="center" alignItems="center">
                                    <Grid item md={12} xs={12}>
                                        <Bar data={this.state.weightReportDataBar} options={this.state.weightReportBarChartOptions} height="180%" redraw={true} />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <br />
                {/* <Grid container spacing={2}>
                    <Grid item md={12} xs={12}>
                        <Card>
                            <CardHeader
                                title="Payment Pending Pickups"
                                className='text-left'
                            />
                            <CardContent>
                                <DataGrid
                                    aria-label="List of Barcoded Bags"
                                    columns={columns}
                                    rows={this.state.payment_pending_pickups}
                                    // pageSize={this.state.pageSize}
                                    // onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                                    // rowsPerPageOptions={[2, 5, 10, 20]}
                                    autoHeight={true}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                    }}
                                    onRowClick={(params: GridRowParams) => {
                                        this.props.history.push('/neighbourhood/customers/' + params.id)
                                    }}
                                    className="clickableList"
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid> */}
                <Modal
                    open={this.state.showCustomDateFilter}
                    onClose={() => this.setState({ showCustomDateFilter: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={t("Select Custom Analytics Dates")}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showCustomDateFilter: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={6} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat="yyyy-MM-dd"
                                                    views={['year', 'month', 'day']}
                                                    mask="____-__-__"
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label={t("From Date") + " *"}
                                                    value={this.state.customFromDate}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ customFromDate: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat="yyyy-MM-dd"
                                                    views={['year', 'month', 'day']}
                                                    mask="____-__-__"
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label={t("To Date") + " *"}
                                                    value={this.state.customToDate}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ customToDate: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showCustomDateFilter: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} disabled={!this.state.customFromDate || !this.state.customToDate} onClick={() => { 
                                    localStorage.setItem('homePageTimePeriod', 'custom');
                                    localStorage.setItem('homePageTimePeriodCustomFromDate', (this.state.customFromDate || '')); 
                                    localStorage.setItem('homePageTimePeriodCustomToDate', (this.state.customToDate || '')); 
                                    this.fetchDashboardAnalytics(); 
                                    this.setState({showCustomDateFilter: false});
                                }}>
                                    {t("Get Analytics")}
                                </Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
            </div>
        )
    }
}

export default withRouter(withTranslation()(Home))